// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3D16w","title":"AfterFrontImage_title__38nDz"};